import React from "react";
import { Route, Routes } from "react-router-dom";
import EditAssociatePage from "./EditAssociatePage";
import ListAssociatePage from "./ListAssociatePage";

export default function AssociatePage() {
    return (
        <Routes>
            <Route
                path="/edit"
                element={<EditAssociatePage />}
            />
            <Route
                path="/list"
                element={<ListAssociatePage />}
            />
        </Routes>
    );
}
